import React ,{useState, useEffect} from 'react';
import {IoLogoPwa, IoLogoApple, IoLogoAndroid} from 'react-icons/io5';
import {Label, Modal, ModalBody, ModalHeader, Button, ModalFooter} from 'reactstrap';
import {MdOutlineInstallDesktop} from "react-icons/md";
import {GrInstallOption} from "react-icons/gr";
import {CiMenuKebab} from "react-icons/ci";
import {IoMdMenu} from "react-icons/io";
import {GoKebabHorizontal} from "react-icons/go";
import {BsBoxArrowUp} from "react-icons/bs";
import { TbCircleNumber1 , TbCircleNumber2  } from "react-icons/tb";

export default function PWAInstallGuide() {
    const [showModal, setShowModal] = useState(false);
    const [platform, setPlatform] = useState('web');
    const [isStandalone, setIsStandalone] = useState(false);

    useEffect(() => {
        const ua = window.navigator.userAgent.toLowerCase();


        if (/iphone|ipad|ipod/.test(ua)) setPlatform('ios');

        else if (/android/.test(ua)) setPlatform('android');
        else setPlatform('web');

        setIsStandalone(
            window.matchMedia('(display-mode: standalone)').matches ||
            window.navigator.standalone
        );
    }, []);

    if (isStandalone) return null;

    const toggleModal = () => setShowModal(!showModal);

    const renderGuideContent = () => {
        switch (platform) {
            case 'ios':
                return (
                    <>
                        <p className={"text-justify"}>
                            <TbCircleNumber1 size={22} className={"text-primary"}/> روش اول:
                            <br/>
                            برای نصب نسخه وب اپلیکیشن روی آیفون روی آیکون <GoKebabHorizontal size={22}
                                                                                             className={"text-primary"}/> کلیک
                            کنید و
                            گزینه share را انتخاب کنید و بعد از کلیک روی دکمه more گزینه Add to Home screen را بزنید.
                        </p>
                        <hr/>
                        <p className={"text-justify"}>
                            <TbCircleNumber2  size={22} className={"text-primary"}/> روش دوم:
                            <br/>
                            در صورت اینکه از نسخه قدیمی ios استفاده میکنید روی آیکون <BsBoxArrowUp size={22}
                                                                                                   className={"text-primary"}/> کلیک
                            کنید و گزینه Add to Home screen را انتخاب کنید.
                        </p>
                    </>
                );
            case 'android':
                return (
                    <>
                        <p className={"text-justify"}>
                            <TbCircleNumber1 size={22} className={"text-primary"}/> روش اول:
                            <br/>
                            در مرورگر موبایل خود در نوبار روی روی دکمه <GrInstallOption size={22}
                                                                                        className={"text-primary"}/> کلیک
                            کنید تا نسخه وب اپلیکشن برای شما نصب شود.
                        </p>
                        <hr/>
                        <p className={"text-justify"}>
                            <TbCircleNumber2  size={22} className={"text-primary"}/> روش دوم:
                            <br/>
                            در صورت نبود دکمه دانلود روی آیکون <CiMenuKebab size={22} className={"text-primary"}/> کلیک
                            کنید و روی گزینه Add to Home screen کلیک کنید.
                        </p>
                    </>
                );
            default:
                return (
                    <>
                        <p className={"text-justify"}>
                            <TbCircleNumber1 size={22} className={"text-primary"}/> روش اول:
                            <br/>

                            برای نصب وبسایت در ویندوز بالای نوبار مرورگر روی آیکون <MdOutlineInstallDesktop size={22}
                                                                                                            className={"text-primary"}/> کلیک
                            کنید تا نسخه وب اپلیکشن روی سیستم شما نصب شود.
                        </p>
                        <hr/>
                        <p className={"text-justify"}>
                            <TbCircleNumber2  size={22} className={"text-primary"}/> روش دوم:
                            <br/>
                            در صورت نبودن آیکون <MdOutlineInstallDesktop size={22}
                                                                         className={"text-primary"}/> روی
                            آیکون <CiMenuKebab size={22} className={"text-primary"}/> کلیک کنید و در گزینه ها گزینه
                            Cast, Save, and share را پیدا و کلیک کنید سپس گزینه نصب را بزنید.
                        </p>
                    </>
                );
        }
    };

    return (
        <>
            <Button color="primary" size={"sm"} onClick={toggleModal} className="d-flex gap-1 align-items-center">
                <IoLogoPwa size={32} className="me-1"/>
                نصب وب اپلیکیشن
            </Button>

            <Modal isOpen={showModal} centered toggle={toggleModal}>
                <ModalHeader>
                    <Label className="h5">راهنمای  نصب وب اپلیکیشن <IoLogoPwa size={32}/></Label>
                </ModalHeader>
                <ModalBody>{renderGuideContent()}</ModalBody>
                <ModalFooter>
                    <Button color={"primary"} className={"w-100"} onClick={toggleModal}>متوجه شدم</Button>
                </ModalFooter>
            </Modal>
        </>
    );
}
